import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPartsReturnsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetPartsReturnsQuery = { __typename?: 'query_root', delivery_returns: Array<{ __typename?: 'delivery_returns', id: number, status: string, return_part_number?: string | null, return_reason: string, return_reason_text?: string | null, return_description?: string | null, return_signature_url?: string | null, return_signer_name?: string | null, requested_at: string, received_at?: string | null, original_order?: { __typename?: 'delivery_orders', id: number, order_number: string, part_number?: string | null } | null, run?: { __typename?: 'mobility_runs', id: number, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', display_name: string } | null } | null } | null, stop?: { __typename?: 'mobility_stops', id: number, address?: string | null } | null }> };


export const GetPartsReturnsDocument = gql`
    query GetPartsReturns($customerId: bigint!) {
  delivery_returns(
    where: {customer_id: {_eq: $customerId}}
    order_by: [{requested_at: desc}]
  ) {
    id
    status
    return_part_number
    return_reason
    return_reason_text
    return_description
    return_signature_url
    return_signer_name
    requested_at
    received_at
    original_order {
      id
      order_number
      part_number
    }
    run {
      id
      driver {
        id
        user {
          display_name
        }
      }
    }
    stop {
      id
      address
    }
  }
}
    `;

/**
 * __useGetPartsReturnsQuery__
 *
 * To run a query within a React component, call `useGetPartsReturnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsReturnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsReturnsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPartsReturnsQuery(baseOptions: Apollo.QueryHookOptions<GetPartsReturnsQuery, GetPartsReturnsQueryVariables> & ({ variables: GetPartsReturnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsReturnsQuery, GetPartsReturnsQueryVariables>(GetPartsReturnsDocument, options);
      }
export function useGetPartsReturnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsReturnsQuery, GetPartsReturnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsReturnsQuery, GetPartsReturnsQueryVariables>(GetPartsReturnsDocument, options);
        }
// @ts-ignore
export function useGetPartsReturnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsReturnsQuery, GetPartsReturnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsReturnsQuery, GetPartsReturnsQueryVariables>;
export function useGetPartsReturnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsReturnsQuery, GetPartsReturnsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsReturnsQuery | undefined, GetPartsReturnsQueryVariables>;
export function useGetPartsReturnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsReturnsQuery, GetPartsReturnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsReturnsQuery, GetPartsReturnsQueryVariables>(GetPartsReturnsDocument, options);
        }
export type GetPartsReturnsQueryHookResult = ReturnType<typeof useGetPartsReturnsQuery>;
export type GetPartsReturnsLazyQueryHookResult = ReturnType<typeof useGetPartsReturnsLazyQuery>;
export type GetPartsReturnsSuspenseQueryHookResult = ReturnType<typeof useGetPartsReturnsSuspenseQuery>;
export type GetPartsReturnsQueryResult = Apollo.QueryResult<GetPartsReturnsQuery, GetPartsReturnsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/getPartsReturns.query.gql}
 */
export async function getPartsReturns(
  variables: GetPartsReturnsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPartsReturnsQuery['delivery_returns']>
export async function getPartsReturns(
  variables: GetPartsReturnsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPartsReturnsQuery>
export async function getPartsReturns(
  variables: GetPartsReturnsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPartsReturnsQuery['delivery_returns'] | GetPartsReturnsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPartsReturnsQuery>(
    GetPartsReturnsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delivery_returns
}